import { MouseEvent } from "react";
import { useHistory } from "react-router-dom";
import {
  MenuSeparator,
  PopoverArrow,
  PopoverContainer,
  PopoverItem,
  PopoverItemsWrapper, PopoverOverlay,
} from "./Popover.style";

interface BottomActionObject extends PopoverItemObject {
  /**
   * Font color
   * @default Normal text color */
  color?: string,
}

interface PopoverItemObject {
  title: string,
  onClick?: () => void,
  redirectUrl?: string,
}

interface PopoverProps {
  /**
   * The last button of the popover, separated by a thin grey line.
   * If all items will not be separated, this bottomAction is not necessary.
   * */
  bottomAction?: BottomActionObject,
  /**
   * A showing state of the popover.
   */
  isShowing: boolean,
  /**
   * An array of popover items.
   */
  items: Array<PopoverItemObject>,
  /**
   * A function to execute when clicking outside the popover.
   */
  onDismiss: (e: MouseEvent<HTMLElement>) => void,
  /**
   * CSS Position if needed to alter.
   * @default "absolute"
   */
  position?: "absolute" | "relative",
}

export const Popover = (props: PopoverProps) => {
  const {
    bottomAction,
    isShowing,
    items,
    onDismiss,
    position = "absolute",
  } = props;
  const history = useHistory();

  const onClickItem = (item: PopoverItemObject) => {
    const { redirectUrl, onClick } = item;

    if (redirectUrl) {
      history.push(redirectUrl);
    }

    if (typeof onClick === 'function') {
      onClick();
    }
  };

  if (!isShowing) {
    return (<></>);
  }

  return (
    <PopoverContainer
      className={'popover-container'}
      position={position}>
      <PopoverArrow />
      <PopoverItemsWrapper
        withBottomAction={Boolean(bottomAction)}>
        {
          items.map((item, index) => (
            <PopoverItem
              key={`popoverItem${index}`}
              onClick={() => onClickItem(item)}>
              { item.title }
            </PopoverItem>
          ))
        }
        {
          bottomAction && (
            <>
              <MenuSeparator />
              <PopoverItem
                color={bottomAction.color}
                onClick={() => onClickItem(bottomAction)}>
                { bottomAction.title }
              </PopoverItem>
            </>
          )
        }
      </PopoverItemsWrapper>
      <PopoverOverlay
        onClick={onDismiss} />
    </PopoverContainer>
  );
};
